/* =============================================================================
 * noteCategories. The coach note categories and how each one reads.
 * -----------------------------------------------------------------------------
 * The web offers general, suggestion, feedback and action_item when a coach
 * writes a note. Notes written in the app can be academic, athletic,
 * recruiting or behavioral. Every screen that shows a note's category uses
 * noteCategoryLabel. Matches backend constants/playerNoteCategories.js.
 * ========================================================================== */

export type NoteCategory =
  | 'general'
  | 'suggestion'
  | 'feedback'
  | 'action_item'
  | 'academic'
  | 'athletic'
  | 'recruiting'
  | 'behavioral';

export const NOTE_CATEGORY_LABELS: Record<NoteCategory, string> = {
  general: 'General',
  suggestion: 'Suggestion',
  feedback: 'Feedback',
  action_item: 'Action Item',
  academic: 'Academic',
  athletic: 'Athletic',
  recruiting: 'Recruiting',
  behavioral: 'Behavioral',
};

export function noteCategoryLabel(category: string | null | undefined): string {
  if (category && Object.prototype.hasOwnProperty.call(NOTE_CATEGORY_LABELS, category)) {
    return NOTE_CATEGORY_LABELS[category as NoteCategory];
  }
  return NOTE_CATEGORY_LABELS.general;
}
